import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthGuard from './auth/AuthGuard';
import { AppProvider } from './providers/AppProvider';
import { TalxisThemeProvider } from './theme';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import SpawnBox from './pages/SpawnBox';
import BoxDetail from './pages/BoxDetail';
import LocalRun from './pages/LocalRun';
import InstanceTerminal from './pages/InstanceTerminal';
import InstanceEditor from './pages/InstanceEditor';
import Workspaces from './pages/Workspaces';
import WorkspaceDetail from './pages/WorkspaceDetail';

export default function App() {
  return (
    <BrowserRouter>
      <AuthGuard>
        <TalxisThemeProvider>
          <AppProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/spawn" element={<SpawnBox />} />
                <Route path="/instances/:id" element={<BoxDetail />} />
                <Route path="/instances/:id/terminal" element={<InstanceTerminal />} />
                <Route path="/instances/:id/terminal/sessions/:sessionName" element={<InstanceTerminal />} />
                <Route path="/instances/:id/editor" element={<InstanceEditor />} />
                <Route path="/local" element={<LocalRun />} />
                <Route path="/workspaces" element={<Workspaces />} />
                <Route path="/workspaces/:id" element={<WorkspaceDetail />} />
              </Route>
            </Routes>
          </AppProvider>
        </TalxisThemeProvider>
      </AuthGuard>
    </BrowserRouter>
  );
}
